import PropTypes from 'prop-types';

import PropTypesPresenter from '../../utils/PropTypesPresenter';

export default new PropTypesPresenter({
  id: PropTypes.number,
  sourceTransactionId: PropTypes.string,
  sourceAccountId: PropTypes.string,
});
